class SessionStorageService {
  save<T>(key: string, object: T): void {
    const json = JSON.stringify(object);
    sessionStorage.setItem(key, json);
  }

  get<T>(key: string): T | null {
    const json = sessionStorage.getItem(key);
    if (json) {
      return JSON.parse(json) as T;
    }
    return null;
  }

  remove(key: string): void {
    sessionStorage.removeItem(key);
  }
}

export default new SessionStorageService();

export const SessionStorageKeys = {
  SessionProjectId: 'SESSION_PROJECT_ID',
  CachedReleaseId: 'SESSION_RELEASEID',
  CachedSearchString: 'SESSION_SEARCHSTRING',
} as const;
